<template>
  <Popup
    :show="open"
    @close="close"
  >
    <template #header>
      <h1>Consent to Pull Consumer Credit Report</h1>
    </template>
    <div class="row">
      <div class="col-sm-12">
        <p>
          <strong>
            By submitting this application, I hereby authorize {{ bankName }} to
            obtain a consumer credit report through a credit reporting agency chosen
            by {{ bankName }}. I understand and agree that {{ bankName }} intends to
            use the consumer credit report for the purposes of evaluating my financial
            readiness to obtain a loan. I understand that this credit report will be
            retained on file with {{ bankName }} for use only by {{ bankName }}. This
            information will not be disclosed to anyone by {{ bankName }} without my
            written consent.
          </strong>
        </p>
      </div>
    </div>

    <template #footer>
      <div class="row">
        <div class="col-sm-12">
          <div class="mt-s col-12">
            <BaseButton
              button-min-width
              @click="close"
            >
              Close
            </BaseButton>
          </div>
        </div>
      </div>
    </template>
  </Popup>
</template>

<script>
import Popup from "../components/ui/Popup.vue";
import BaseButton from "../components/ui/BaseButton.vue";

export default {
  name: "CreditCheckModal",

  components: {
    Popup,
    BaseButton,
  },

  props: {
    open: {
      type: Boolean,
      default: false
    },
    bankName: {
      type: String,
      required: true,
    },
  },

  methods: {
    close() {
      this.$emit("close");
    }
  }
};
</script>
